import api from "api";

export const assetActionService = {
  assetPublishOrUnpublish
};

async function assetPublishOrUnpublish(assetId: string, action: string, userId: string): Promise<Response> {
  const url = `${api.config.publishOrUnpublishAsset(assetId, action, userId)}`;
  return await fetch(url, {
    headers: {
      "userId": userId,
      'Content-Type': 'application/json',
    },
    method: 'PUT',
  });
}